import React, { useState } from "react";
import { toast } from "sonner";
import { AlertTriangle, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

// Confirmation de publication d'une version des CGU.
export default function CguPublishDialog({ v, onClose, onDone }) {
  const [reaccept, setReaccept] = useState(true);
  const [confirm, setConfirm] = useState(false);
  const [ignore, setIgnore] = useState(false);
  const [busy, setBusy] = useState(false);
  const left = v.placeholders || 0;

  const publish = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/cgu/versions/${v.id}/publish`, { requires_acceptance: reaccept, confirm, ignore_placeholders: ignore });
      toast.success(`Version ${v.version} publiée`); onDone();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center bg-black/60 p-4" data-testid="cgu-publish-dialog">
      <div className="max-h-[90vh] w-full max-w-lg overflow-y-auto rounded-3xl bg-[#FFF8F1] p-5 street-border">
        <h3 className="font-[Outfit] text-[20px] font-black">Publier la version {v.version} ?</h3>
        <p className="mt-1 text-[13px] font-semibold text-foreground/70">Elle remplacera immédiatement la version en vigueur sur le site et dans l&apos;application.</p>
        {left > 0 && (
          <div className="mt-3 rounded-2xl bg-red-100 p-3 text-[12px] font-bold text-red-900" data-testid="cgu-publish-placeholders">
            <div className="flex items-center gap-1.5 font-black"><AlertTriangle className="h-4 w-4" />{left} passage(s) entre crochets restent à compléter :</div>
            <ul className="mt-1 list-disc pl-5">{(v.placeholder_list || []).slice(0, 8).map((p, i) => <li key={i}>{p}</li>)}</ul>
            <label className="mt-2 flex items-start gap-2">
              <input type="checkbox" checked={ignore} onChange={(e) => setIgnore(e.target.checked)} className="mt-0.5" data-testid="cgu-publish-ignore-placeholders" />
              Publier quand même (déconseillé)
            </label>
          </div>
        )}
        <label className="mt-3 flex items-start gap-2 text-[13px] font-bold">
          <input type="checkbox" checked={reaccept} onChange={(e) => setReaccept(e.target.checked)} className="mt-0.5" data-testid="cgu-publish-reaccept" />
          Modification importante : tous les utilisateurs devront accepter cette version avant de continuer
        </label>
        <label className="mt-2 flex items-start gap-2 text-[13px] font-bold">
          <input type="checkbox" checked={confirm} onChange={(e) => setConfirm(e.target.checked)} className="mt-0.5" data-testid="cgu-publish-confirm" />
          Je confirme que ce texte a été relu et validé pour publication
        </label>
        <div className="mt-4 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="rounded-full bg-white px-4 py-2 text-[13px] font-black street-border-thin" data-testid="cgu-publish-cancel">Annuler</button>
          <button type="button" disabled={!confirm || (left > 0 && !ignore) || busy} onClick={publish}
            className="street-press inline-flex items-center gap-1.5 rounded-full bg-primary px-4 py-2 text-[13px] font-black text-primary-foreground street-border-thin disabled:opacity-50" data-testid="cgu-publish-submit">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}Publier
          </button>
        </div>
      </div>
    </div>
  );
}
